"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortInfoToSortOptionValue = exports.sortOptionToSortInfo = void 0;
exports.sortOptionToSortInfo = function (value) {
    if (value === 0)
        return ({ sortBy: 'qualityscore', orderBy: 'desc' });
    if (value === 1)
        return ({ sortBy: 'price', orderBy: 'asc' });
    if (value === 2)
        return ({ sortBy: 'price', orderBy: 'desc' });
    if (value === 3)
        return ({ sortBy: 'pricepersqft', orderBy: 'asc' });
    if (value === 4)
        return ({ sortBy: 'pricepersqft', orderBy: 'desc' });
    if (value === 5)
        return ({ sortBy: 'netsize', orderBy: 'desc' });
    if (value === 6)
        return ({ sortBy: 'netsize', orderBy: 'asc' });
    if (value === 7)
        return ({ sortBy: 'district', orderBy: 'asc' });
    if (value === 8)
        return ({ sortBy: 'district', orderBy: 'desc' });
    if (value === 9)
        return ({ sortBy: 'name', orderBy: 'asc' });
    if (value === 10)
        return ({ sortBy: 'name', orderBy: 'desc' });
    return ({ sortBy: 'updateddate', orderBy: 'desc' });
};
exports.sortInfoToSortOptionValue = function (sortBy, orderBy) {
    if (sortBy === 'price' && orderBy === 'asc')
        return 1;
    if (sortBy === 'price' && orderBy === 'desc')
        return 2;
    if (sortBy === 'pricepersqft' && orderBy === 'asc')
        return 3;
    if (sortBy === 'pricepersqft' && orderBy === 'desc')
        return 4;
    if (sortBy === 'netsize' && orderBy === 'desc')
        return 5;
    if (sortBy === 'netsize' && orderBy === 'asc')
        return 6;
    if (sortBy === 'district' && orderBy === 'asc')
        return 7;
    if (sortBy === 'district' && orderBy === 'desc')
        return 8;
    if (sortBy === 'name' && orderBy === 'asc')
        return 9;
    if (sortBy === 'name' && orderBy === 'desc')
        return 10;
    if (sortBy === 'updateddate' && orderBy === 'desc')
        return 11;
    return 0;
};
